import numeral from 'numeral'

export const numberFormat = (n) => typeof n === 'number' ? numeral(n).format('0,0') : n

const getDigits = (n) => n?.toString()?.length || 0

export const numberToMillion = (no) => {
  const n = typeof no === 'string' ? parseInt(no) : no
  const dig = getDigits(n)

  if (dig >= 4 && dig < 7) {
    return `${(n / 1000).toFixed(1)}k`
  } else if (dig >= 7 && dig < 10) {
    return `${(n / 1000000).toFixed(1)}m`
  } else if (dig >= 10) {
    return `${(n / 1000000000).toFixed(1)}bn`
  } else {
    return n
  }
}

export const round = (n, d) => Math.round(n * (10 ^ d)) / (10 ^ d)

export const inputNumber = (e) => {
  if (e.target.value.includes(',')) e.target.value = e.target.value.replace(/,/g, '')
  const parsed = e.target.value ? parseInt(e.target.value) : null
  return isNaN(parsed) ? '' : parsed ? parsed.toLocaleString('en-GB', { minimumFractionDigits: 0 }) : ''
}

export const inputNumber2 = (e) => {
  if (e.target.value.includes('.')) {
    const sp = e.target.value.replace(/,/g, '').split('.')
    const d1 = e.target.value
      ? parseInt(sp[0]).toLocaleString('en-GB', { minimumFractionDigits: 0 })
      : null
    return `${d1}.${sp[1]}`
  } else {
    if (e.target.value.includes(',')) e.target.value = e.target.value.replace(/,/g, '')
    return e.target.value ? parseInt(e.target.value)?.toLocaleString('en-GB', { minimumFractionDigits: 0 }) : null
  }
}

export const outputNumber = (val) => {
  if (typeof val === 'string') return parseInt(val.replace(/,/g, ''))
  else return val
}

export const outputNumber2 = (val) => {
  if (typeof val === 'string') {
    const s1 = val.replace(/,/g, '')
    const hasDec = s1.includes('.')

    if (hasDec) {
      const s2 = s1.split('.')
      return parseInt(s2[0]) + (parseInt(s2[1]) / 100)
    } else return parseInt(s1)
  } else return val
}
